export var FieldFilterOperator;
(function (FieldFilterOperator) {
    FieldFilterOperator["Is"] = "IS";
    FieldFilterOperator["IsNot"] = "IS_NOT";
    FieldFilterOperator["OneOf"] = "ONE_OF";
    FieldFilterOperator["NotOneOf"] = "NOT_ONE_OF";
    FieldFilterOperator["Exists"] = "EXISTS";
    FieldFilterOperator["NotExists"] = "NOT_EXISTS";
    FieldFilterOperator["IsBetween"] = "IS_BETWEEN";
    FieldFilterOperator["IsNotBetween"] = "IS_NOT_BETWEEN";
})(FieldFilterOperator || (FieldFilterOperator = {}));
//# sourceMappingURL=field-filter.enum.js.map